import React, {useRef} from "react";
import './modal-overlay.scss';
import {setTrap} from "../../utils/trap-focus";
// Defining the <Greeting> component

export const ModalOverlay = (props) => {

  const modal = useRef(null);
  setTrap(modal.current)
  if(typeof document !== "undefined"){
    if(props.stateOverlay  ){
      document.body.classList.add('openModal');
    }else {
      if(document.body.classList.contains('openModal')){
        document.body.classList.remove('openModal')
      }
    }  
  }
  
  return (
        <div className={`${props.stateOverlay ? 'modalOverlay__overlay--visible' : ''} modalOverlay__overlay`} ref={modal}>
          <div className="modalOverlay__overlayContet">
            <a href="#" className="modalOverlay__overlayClose" aria-label="close action" onClick={props.onCloseOverlay}>
              <span className="modalOverlay__overlayIconClose i-close"></span>
            </a>
            {
              props.titleModal && 
              <h3 className="modalOverlay__overlayTitle">
                {props.titleModal}
                {
                props.iconTitle &&
                <span className={`modalOverlay__overlayTitleIcon ${props.iconTitle}`}></span>
                }
              </h3>
            }
            {
              props.descModal && 
              <p className="modalOverlay__overlayDesc">{props.descModal}</p>
            }
            {
              props.contentImage === 'true' && 
              <div className="modalOverlay__overlayContentImage">
                <img src={props.srcImage1} className="modalOverlay__overlayImageIn" alt="overlay"/>
                <img src={props.srcImage2} className="modalOverlay__overlayImageIn" alt="overlay"/>
              </div>
            }
            {
              props.codeImage === 'true' && 
              <div>
                <span className="modalOverlay__overlayIcon"></span>
                <img src={props.srcCode} className="modalOverlay__overlayImageCode"/>
              </div>
            }
          </div>
        </div>    
    )
  }